"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FileUploadController = /** @class */ (function () {
    function FileUploadController($scope, fileUploadApi) {
        var _this = this;
        this.$scope = $scope;
        this.fileUploadApi = fileUploadApi;
        this.isValidExtension = true;
        this.isConfigured = false;
        this.isUploading = false;
        this.uploadFiles = function (files) {
            if (!files || !files.length) {
                return;
            }
            _this.isUploading = true;
            var file = files[0];
            // if allowed file types are specified, make sure to upload files with allowed extensions only
            if (file.name && _this.allowedFileTypes) {
                var fileExtension = file.name.split('.').pop();
                if (_this.allowedFileTypes.indexOf(fileExtension) === -1) {
                    _this.isUploading = false;
                    _this.isValidExtension = false;
                    return;
                }
            }
            _this.file = file;
            _this.isValidExtension = true;
            if (!_this.isConfigured) {
                _this.fileUploadApi.configureUpload(_this.upload);
            }
            _this.fileUploadApi.uploadFile(_this.file);
        };
    }
    FileUploadController.prototype.$onInit = function () {
        var _this = this;
        this.fileUploadApi.configureUpload(this.upload);
        this.progress = this.fileUploadApi.uploadProgress;
        this.$scope.$on('fileUploadProgress', function (event, uploadProgress) {
            _this.progress = parseInt(uploadProgress, 10);
            if (uploadProgress === 100) {
                _this.isUploading = false;
            }
        });
    };
    FileUploadController.prototype.init = function (uploadTarget, projectId, taskId, tempTaskId, fileName, fileSize, allowedTypes) {
        this.upload = {
            target: uploadTarget,
            projectId: projectId,
            taskId: taskId,
            tempTaskId: tempTaskId
        };
        this.allowedFileTypes = allowedTypes;
        if (!this.file) {
            this.file = FileUploadController.createFile(fileName, fileSize);
        }
    };
    FileUploadController.createFile = function (name, size) {
        return {
            name: name,
            size: size,
            lastModifiedDate: Date.now(),
            lastModified: Date.now(),
            type: '',
            slice: function () { return null; }
        };
    };
    return FileUploadController;
}());
exports.FileUploadController = FileUploadController;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZmlsZVVwbG9hZC5jb250cm9sbGVyLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiZmlsZVVwbG9hZC5jb250cm9sbGVyLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBSUE7SUFTSSw4QkFBb0IsTUFBTSxFQUFVLGFBQWlDO1FBQXJFLGlCQUNDO1FBRG1CLFdBQU0sR0FBTixNQUFNLENBQUE7UUFBVSxrQkFBYSxHQUFiLGFBQWEsQ0FBb0I7UUFKOUQscUJBQWdCLEdBQVksSUFBSSxDQUFDO1FBQ2hDLGlCQUFZLEdBQVksS0FBSyxDQUFDO1FBQzlCLGdCQUFXLEdBQVksS0FBSyxDQUFDO1FBZ0M5QixnQkFBVyxHQUFHLFVBQUMsS0FBYTtZQUMvQixJQUFJLENBQUMsS0FBSyxJQUFJLENBQUMsS0FBSyxDQUFDLE1BQU0sRUFBRTtnQkFDekIsT0FBTzthQUNWO1lBRUQsS0FBSSxDQUFDLFdBQVcsR0FBRyxJQUFJLENBQUM7WUFDeEIsSUFBTSxJQUFJLEdBQUcsS0FBSyxDQUFDLENBQUMsQ0FBQyxDQUFDO1lBRXRCLDhGQUE4RjtZQUM5RixJQUFJLElBQUksQ0FBQyxJQUFJLElBQUksS0FBSSxDQUFDLGdCQUFnQixFQUFFO2dCQUNwQyxJQUFNLGFBQWEsR0FBRyxJQUFJLENBQUMsSUFBSSxDQUFDLEtBQUssQ0FBQyxHQUFHLENBQUMsQ0FBQyxHQUFHLEVBQUUsQ0FBQztnQkFFakQsSUFBSSxLQUFJLENBQUMsZ0JBQWdCLENBQUMsT0FBTyxDQUFDLGFBQWEsQ0FBQyxLQUFLLENBQUMsQ0FBQyxFQUFFO29CQUNyRCxLQUFJLENBQUMsV0FBVyxHQUFHLEtBQUssQ0FBQztvQkFDekIsS0FBSSxDQUFDLGdCQUFnQixHQUFHLEtBQUssQ0FBQztvQkFDOUIsT0FBTztpQkFDVjthQUNKO1lBRUQsS0FBSSxDQUFDLElBQUksR0FBRyxJQUFJLENBQUM7WUFFakIsS0FBSSxDQUFDLGdCQUFnQixHQUFHLElBQUksQ0FBQztZQUU3QixJQUFJLENBQUMsS0FBSSxDQUFDLFlBQVksRUFBRTtnQkFDcEIsS0FBSSxDQUFDLGFBQWEsQ0FBQyxlQUFlLENBQUMsS0FBSSxDQUFDLE1BQU0sQ0FBQyxDQUFDO2FBQ25EO1lBRUQsS0FBSSxDQUFDLGFBQWEsQ0FBQyxVQUFVLENBQUMsS0FBSSxDQUFDLElBQUksQ0FBQyxDQUFDO1FBQzdDLENBQUMsQ0FBQztJQXpERixDQUFDO0lBRUQsc0NBQU8sR0FBUDtRQUFBLGlCQVVDO1FBVEcsSUFBSSxDQUFDLGFBQWEsQ0FBQyxlQUFlLENBQUMsSUFBSSxDQUFDLE1BQU0sQ0FBQyxDQUFDO1FBQ2hELElBQUksQ0FBQyxRQUFRLEdBQUcsSUFBSSxDQUFDLGFBQWEsQ0FBQyxjQUFjLENBQUM7UUFDbEQsSUFBSSxDQUFDLE1BQU0sQ0FBQyxHQUFHLENBQUMsb0JBQW9CLEVBQUUsVUFBQyxLQUFLLEVBQUUsY0FBYztZQUN4RCxLQUFJLENBQUMsUUFBUSxHQUFHLFFBQVEsQ0FBQyxjQUFjLEVBQUUsRUFBRSxDQUFDLENBQUM7WUFFN0MsSUFBSSxjQUFjLEtBQUssR0FBRyxFQUFFO2dCQUN4QixLQUFJLENBQUMsV0FBVyxHQUFHLEtBQUssQ0FBQzthQUM1QjtRQUNMLENBQUMsQ0FBQyxDQUFDO0lBQ1AsQ0FBQztJQUVNLG1DQUFJLEdBQVgsVUFBWSxZQUFZLEVBQUUsU0FBUyxFQUFFLE1BQU0sRUFBRSxVQUFVLEVBQUUsUUFBUSxFQUFFLFFBQVEsRUFBRSxZQUFZO1FBQ3JGLElBQUksQ0FBQyxNQUFNLEdBQUc7WUFDVixNQUFNLEVBQUUsWUFBWTtZQUNwQixTQUFTLEVBQUUsU0FBUztZQUNwQixNQUFNLEVBQUUsTUFBTTtZQUNkLFVBQVUsRUFBRSxVQUFVO1NBQ3pCLENBQUM7UUFFRixJQUFJLENBQUMsZ0JBQWdCLEdBQUcsWUFBWSxDQUFDO1FBRXJDLElBQUksQ0FBQyxJQUFJLENBQUMsSUFBSSxFQUFFO1lBQ1osSUFBSSxDQUFDLElBQUksR0FBRyxvQkFBb0IsQ0FBQyxVQUFVLENBQUMsUUFBUSxFQUFFLFFBQVEsQ0FBQyxDQUFDO1NBQ25FO0lBQ0wsQ0FBQztJQWdDYywrQkFBVSxHQUF6QixVQUEwQixJQUFZLEVBQUUsSUFBWTtRQUNoRCxPQUFPO1lBQ0gsSUFBSSxFQUFFLElBQUk7WUFDVixJQUFJLEVBQUUsSUFBSTtZQUNWLGdCQUFnQixFQUFFLElBQUksQ0FBQyxHQUFHLEVBQUU7WUFDNUIsWUFBWSxFQUFFLElBQUksQ0FBQyxHQUFHLEVBQUU7WUFDeEIsSUFBSSxFQUFFLEVBQUU7WUFDUixLQUFLLEVBQUUsY0FBTSxPQUFBLElBQUksRUFBSixDQUFJO1NBQ2IsQ0FBQztJQUNiLENBQUM7SUFDTCwyQkFBQztBQUFELENBQUMsQUEvRUQsSUErRUM7QUEvRVksb0RBQW9CIn0=